// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.w-card-content[data-v-eb23fc96] { text-align: left; background: #fbfcfd;\n}\niframe[data-v-eb23fc96] { width: 100%; height: 100%; border: none; min-height: 700px; margin-top: -50px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
